import { useState, useEffect, useCallback } from "react";
import {  Icon, apiFetch,  apiPatch, Loader, ini, avaClass, TECH_API } from "./apihandler";

function WorkProgressPage({ camp, onBack, onNext }) {
  const [rows, setRows] = useState([]);
  const [techs, setTechs] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState({});

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      apiFetch(`${TECH_API}/work-progress/?camp_id=${camp.id}`),
      apiFetch(`${TECH_API}/camp/${camp.id}/assignments/`),
    ])
      .then(([prog, asgn]) => {
        setRows(Array.isArray(prog) ? prog : prog.results || []);
        // build technician list from assignments
        const techMap = {};
        (Array.isArray(asgn) ? asgn : asgn.results || []).forEach((a, i) => {
          const id = a.technician || a.technician_id;
          if (id && !techMap[id]) {
            techMap[id] = { id, name: a.technician_name || a.technician?.name || `Tech #${id}`, colorIdx: i };
          }
        });
        setTechs(Object.values(techMap));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [camp.id]);

  useEffect(() => { load(); }, [load]);

  const toggleDone = async (row) => {
    setToggling(p => ({ ...p, [row.id]: true }));
    try {
      await apiPatch(`${TECH_API}/work-progress/${row.id}/`, { is_completed: !row.is_completed });
      setRows(p => p.map(r => r.id === row.id ? { ...r, is_completed: !r.is_completed } : r));
    } catch { /* ignore */ }
    setToggling(p => ({ ...p, [row.id]: false }));
  };

  const filtered = filter === "all" ? rows : rows.filter(r => String(r.technician || r.technician_id) === String(filter));
  const done = filtered.filter(r => r.is_completed).length;
  const total = filtered.length;
  const pct = total ? Math.round(done / total * 100) : 0;

  return (
    <div className="page">
      <div className="ph">
        <Icon n="activity" size={18} />
        {camp.name || `Camp #${camp.id}`}
        <span className="ph-sub">— work progress</span>
      </div>

      <div className="met-grid">
        <div className="met"><div className="met-v">{total}</div><div className="met-l">Total services</div></div>
        <div className="met"><div className="met-v" style={{ color: "var(--green)" }}>{done}</div><div className="met-l">Completed</div></div>
        <div className="met"><div className="met-v" style={{ color: "var(--amber)" }}>{total - done}</div><div className="met-l">Pending</div></div>
        <div className="met"><div className="met-v">{pct}%</div><div className="met-l">Completion</div></div>
      </div>

      <div className="tech-filter">
        <button className={`tf-btn${filter === "all" ? " active" : ""}`} onClick={() => setFilter("all")}>All technicians</button>
        {techs.map(t => (
          <button key={t.id} className={`tf-btn${filter === String(t.id) ? " active" : ""}`} onClick={() => setFilter(String(t.id))}>
            {t.name}
          </button>
        ))}
      </div>

      <div className="card">
        <div className="sl"><Icon n="activity" size={14} /> Service status per patient</div>
        <div className="info-note" style={{ marginBottom: ".75rem" }}>
          <Icon n="stethoscope" size={15} />
          <span>Technician marks their own completed <code style={{ fontSize: 11, background: "#B5D4F4", padding: "1px 5px", borderRadius: 4 }}>ServiceStatus</code> rows.</span>
        </div>

        {loading && <Loader text="Loading progress…" />}

        {!loading && filtered.length === 0 && <div className="empty">No records for this selection.</div>}

        {!loading && filtered.map((r, i) => {
          const techObj = techs.find(t => String(t.id) === String(r.technician || r.technician_id));
          const patient = r.patient_name || r.patient || `Patient #${r.patient_id || i + 1}`;
          const service = r.service_name || r.service || "—";
          return (
            <div
              key={r.id}
              className="prog-row"
              onClick={() => !toggling[r.id] && toggleDone(r)}
            >
              <div className={`chkbox${r.is_completed ? " on" : ""}`}>
                {r.is_completed && <Icon n="check" size={11} />}
              </div>
              {techObj && (
                <div className={`ava ${avaClass(techObj.colorIdx)}`} style={{ width: 26, height: 26, fontSize: 10 }}>
                  {ini(techObj.name)}
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13 }}>{patient}</div>
                <div style={{ fontSize: 11, color: "var(--text2)" }}>{service}</div>
              </div>
              <span className={`pill ${r.is_completed ? "pill-green" : "pill-amber"}`}>
                {r.is_completed ? <><Icon n="check" size={11} /> Done</> : <><Icon n="clock" size={11} /> Pending</>}
              </span>
            </div>
          );
        })}
      </div>

      <div className="btn-between">
        <button className="btn" onClick={onBack}><Icon n="arrowL" size={15} /> Back</button>
        <button className="btn btn-pri" onClick={onNext}>Go to payment <Icon n="arrowR" size={15} /></button>
      </div>
    </div>
  );
}

export default WorkProgressPage;